import { Icon, Card, Popup } from "semantic-ui-react";
import { Carousel } from "react-responsive-carousel";
import {
  assetTypeToPlaceholderIcon,
  formatInformationLength,
  handleDownloadClick,
} from "services/common";
import AssetCardInformation from "components/AssetCardInformation/AssetCardInformation";
import AssetImage from "components/AssetImage/AssetImage";

const RenderAssets = (props) => {
  const { assets, t } = props;

  const renderCards = (assets) => {
    return assets.map((asset, i) => {
      return (
        <Card key={i} className="">
          <Card.Content>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                maxHeight: "150px",
                overflow: "hidden",
              }}
            >
              <AssetImage asset={asset} />
            </div>
            <Card.Header style={{ marginTop: "1rem", wordBreak: "break-all", display: "flex" }}>
              <div className="material-type">
                {assetTypeToPlaceholderIcon(asset.type, "large")}
                <Popup
                  content={asset.name}
                  position="top center"
                  on="hover"
                  disabled={!asset.name || asset.name.length <= 18}
                  trigger={<span>{formatInformationLength(asset.name, 18)}</span>}
                />
              </div>
            </Card.Header>
            <AssetCardInformation asset={asset} maxLength={18} t={t} />
            <a
              href={asset.mediaUrl}
              title={t("campaigns_download_link_title", { assetName: asset.name })}
              onClick={(e) => handleDownloadClick(e, asset.mediaUrl, t)}
            >
              <Icon name="cloud download" size="large" /> {t("asset_download")}
            </a>
          </Card.Content>
        </Card>
      );
    });
  };

  if (assets.length <= 8) {
    return (
      <div className="campaign-info">
        <div className="minimum-assets">
          <Card.Group itemsPerRow={4}>{renderCards(assets)}</Card.Group>
        </div>
      </div>
    );
  } else {
    const carouselItemsLength = Math.floor(Math.abs(assets.length / 8) + 1);
    const assetsSlice = Array.from(Array(carouselItemsLength), (x, index) => 0 + index * 8);
    const campaignAssetsCarousel = [];
    for (let i = 0; i < assetsSlice.length; i++) {
      let superiorLimit = assetsSlice[i] + 8 < assets.length ? assetsSlice[i] + 8 : assets.length;
      campaignAssetsCarousel.push(assets.slice(assetsSlice[i], superiorLimit));
    }
    return (
      <div className="campaign-info">
        <Carousel showThumbs={false}>
          {campaignAssetsCarousel.map((subArray, index) => {
            return (
              <div key={index}>
                <Card.Group itemsPerRow={4}>{renderCards(subArray)}</Card.Group>
              </div>
            );
          })}
        </Carousel>
      </div>
    );
  }
};

export default RenderAssets;
